<template>
  <div v-if="post.synopsis" class="synopsis-card glass-card pa-6 mb-6">
    <div class="d-flex align-center ga-2 mb-3">
      <v-icon color="primary" size="20">mdi-text-box-outline</v-icon>
      <h3 class="text-subtitle-1 font-weight-bold mb-0">Storyline & Synopsis</h3>
    </div>
    <p class="synopsis-text text-body-1 mb-0">{{ post.synopsis }}</p>
  </div>
</template>

<script>
export default {
  name: 'MovieSynopsis',
  props: {
    post: { type: Object, required: true },
  },
}
</script>

<style scoped>
.synopsis-text {
  line-height: 1.75;
  font-size: 1.05rem;
  letter-spacing: 0.01em;
  opacity: 0.9;
}
</style>

